module.exports = __webpack_public_path__ + "img/nav-red.d56994c0.svg";